var $ = require("jquery");

jQuery(function () {
    $('#newsletter-form').on('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();
        let loadingSpin = $(document).find('.loadingsvg').clone();
        $('#newsletter-response').html(loadingSpin).fadeIn();
        $('#newsletter-submit-btn').attr('disabled', 'disabled');
        var data = $(this).serialize();

        // Send it to the server
        $.post('/wheelform/message/send',
            data,
            function (response) {
                if (response.success) {
                    resp = response.message;
                    //send user data to mailchimp list
                    // prep data for mailchimp
                    var mailchimp_data = {
                        'CRAFT_CSRF_TOKEN': $('#newsletter-form').find('input[name="CRAFT_CSRF_TOKEN"]').val(),
                        'merge_fields': {
                            'FNAME': $('#newsletter-form').find('input#firstname').val(),
                            'LNAME': $('#newsletter-form').find('input#lastname').val(),
                        },
                        'email': $('#newsletter-form').find('input#email').val(),
                        'audienceId': $('#newsletter-form').find('input#audienceId').val(),
                        'language': 'it'
                    };
                    
                    $.ajax({
                        headers: {
                            'Accept': "application/json",
                            'Content-Type': "application/json"
                        },
                        url: '/actions/mailchimp-subscribe/audience/subscribe',
                        type: 'post',
                        dataType: 'json',
                        data: JSON.stringify(mailchimp_data),
                        success: function (response) {
                            if(response.success){
                                respMC = 'Riceverai tra poco una mail con le istruzioni per finalizzare la registrazione.';
                                // analytics event newsletter
                                if (typeof gtag === 'function') {
                                    gtag('event', 'generate_lead', {
                                        'event_category': 'form',
                                        'event_action': 'send',
                                        'event_label': 'newsletter'
                                    });
                                }
                                if (typeof fbq === 'function') {
                                    fbq('track', 'CompleteRegistration',{'content_name': 'form newsletter'});
                                }
                                $('#newsletter-mailchimp-response').empty().html('<p class="form-thanks">' + respMC + '</p>').fadeIn();
                            } else {
                                console.log(response);
                                respMC = 'Si è verificato un errore: ' + response.message;
                                $('#newsletter-mailchimp-response').empty().html('<p class="form-errors">' + respMC + '</p>').fadeIn();
                            }
                        },
                        error: function(response){
                            respMC = resp + 'Si è verificato un errore con il server durante la registrazione.'
                            $('#newsletter-mailchimp-response').empty().html('<p class="form-errors">' + respMC + '</p>').fadeIn();
                        }

                    });

                    $('#newsletter-response').empty().html('<p class="form-thanks">' + resp + '</p>').fadeIn();
                    $('#newsletter-form')[0].reset();
                    $('#newsletter-submit-btn').removeAttr('disabled');
                } else {
                    // response.values will contain user submitted values
                    // response.errors will be an array containing any validation errors that occurred, indexed by field name
                    // e.g. response.error['email'] => ['Email is required', 'Email is invalid']
                    var errors = jQuery.map(response.errors, function (a) {
                        return a[0];
                    });
                    $('#newsletter-response').empty().html('<p class="form-errors">Attenzione:<br> ' + errors.join("<br>") + '</p>').fadeIn();
                    $('#newsletter-submit-btn').removeAttr('disabled');
                }
            }
        );
    });
});